import { FC, useEffect, useRef, useState } from 'react';
import { t } from '@whitesharx/starfall-frontend-ttranslate';
import { circleStyles, containerStyles, iconStyles, meterStyles, progressStyles, titleStyles } from './styles.css';
import { isSafari, isMacOS } from '~/src/constants/env';

type Props = {
  value: number;
};

const INITIAL_STROKE_DASHOFFSET = 282.78302001953125;

const Progress: FC<Props> = ({ value }) => {
  const ref = useRef<SVGPathElement>(null);
  const [strokeDashoffset, setStrokeDashoffset] = useState(INITIAL_STROKE_DASHOFFSET);

  useEffect(() => {
    if (ref.current) {
      const length = ref.current.getTotalLength();
      const to = length * ((100 - value) / 100);
      setStrokeDashoffset(Math.max(0, to));
    }
  }, [value, ref]);

  return (
    <div className={containerStyles}>
      <svg
        viewBox="0 0 100 100"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="none"
        data-value={value}
        className={progressStyles}
      >
        <circle r="45" cx="50" cy="50" className={circleStyles} />

        <path
          className={meterStyles}
          d="M5,50a45,45 0 1,0 90,0a45,45 0 1,0 -90,0"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeDashoffset={strokeDashoffset}
          strokeDasharray="282.78302001953125"
          ref={ref}
        />

        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M60.055 35.214C56.8689 31.9925 52.4698 30 47.6078 30C42.7471 30 38.3442 31.9925 35.1568 35.214C31.9706 38.4369 30 42.8874 30 47.8034C30 52.7195 31.9706 57.1674 35.1568 60.3889C38.3429 63.6104 42.7471 65.6029 47.6078 65.6029C51.0529 65.6029 54.2666 64.602 56.9808 62.8721L63.3202 69.2819C64.8474 70.8301 67.324 70.8301 68.8512 69.2819C70.3824 67.7378 70.3824 65.2336 68.8512 63.6894L62.5116 57.2794C64.2221 54.5353 65.2117 51.2863 65.2117 47.8034C65.2117 42.8887 63.2411 38.4356 60.055 35.214ZM47.6078 35.2734C51.0274 35.2734 54.1249 36.6751 56.3654 38.9446C58.61 41.2101 59.9963 44.3459 59.9963 47.8034C59.9963 51.261 58.61 54.3929 56.3654 56.6584C54.1249 58.9278 51.0313 60.3295 47.6078 60.3295C44.1843 60.3295 41.0869 58.9278 38.8463 56.6584C36.6018 54.3929 35.2154 51.265 35.2154 47.8034C35.2154 44.3419 36.6018 41.2101 38.8463 38.9446C41.0869 36.6751 44.1883 35.2734 47.6078 35.2734Z"
          fill="#D9D7D9"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M58.0557 47.8035H37.1574C37.1574 50.7191 38.326 53.3617 40.2183 55.2724C42.1081 57.1858 44.7217 58.3674 47.6079 58.3674H47.7226V37.2369C50.5618 37.2672 53.1311 38.4448 54.9948 40.3318C56.8871 42.2426 58.0557 44.8852 58.0557 47.8035Z"
          fill="#D9D7D9"
          className={!(isMacOS && isSafari) ? iconStyles : undefined}
        />
      </svg>
      <span className={titleStyles}>{t('analysis.game-analysis')}...</span>
    </div>
  );
};

export default Progress;
